import { useCallback } from 'react'
import { useSearchParams } from 'react-router'

import { isCancellationStatus, type CancellationStatus } from './cancellationStatusConfig'

const DEFAULT_TAB: CancellationStatus = 'REQUESTED'

function parseStatus(value: string | null): CancellationStatus {
  if (value && isCancellationStatus(value)) {
    return value
  }
  return DEFAULT_TAB
}

function parsePage(value: string | null): number {
  const num = Number(value)
  return Number.isInteger(num) && num >= 1 ? num : 1
}

/**
 * The query string is the single source of truth for the 취소 요청 list state — see
 * `useOrderListUrlSync` for why mirroring component state back into the URL was wrong.
 */
export function useCancellationListUrlSync() {
  const [searchParams, setSearchParams] = useSearchParams()

  const activeTab = parseStatus(searchParams.get('status'))
  const currentPage = parsePage(searchParams.get('page'))

  const setTab = useCallback(
    (tab: CancellationStatus) => {
      setSearchParams({ status: tab })
    },
    [setSearchParams],
  )

  const setPage = useCallback(
    (page: number) => {
      setSearchParams((previous) => {
        const next = new URLSearchParams(previous)
        if (page > 1) next.set('page', String(page))
        else next.delete('page')
        return next
      })
    },
    [setSearchParams],
  )

  return { activeTab, currentPage, setTab, setPage } as const
}
